var CLASSNAME_PREFIXES = {
  AVATAR_CLUSTER: "_mntl-avatar-cluster",
  AVATAR_TEAM: "_mntl-avatar-team",
  AVATAR_USER: "_mntl-avatar-user"
};

export { CLASSNAME_PREFIXES };
